import { render } from "./homes.vue?vue&type=template&id=338950d8&scoped=true"
import script from "./homes.vue?vue&type=script&lang=js"
export * from "./homes.vue?vue&type=script&lang=js"

import "./homes.vue?vue&type=style&index=0&id=338950d8&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\mac\\Downloads\\PCguanli\\zhongtaiworkPC\\yungong_1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-338950d8"]])

export default __exports__